import { Box, Grid, List, ListItem, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import Button from "components/Button"
import { useTranslation } from "react-i18next"

interface Department {
  id: number
  name: string
  description: string
}

interface DepartmentsListProps {
  departments: Department[]
  removeDepartment: (department: Department) => void
}
const DepartmentsList = ({ departments, removeDepartment }: DepartmentsListProps) => {
  const { t } = useTranslation()

  return (
    <List>
      {departments.map((item, key) => {
        return (
          <ListItem key={key} divider disableGutters>
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="bodySmall"> {item.name}</Typography>

                <Typography variant="caption" style={{ color: grey[600] }}>
                  {" "}
                  {item.description}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    onClick={() => {
                      removeDepartment(item)
                    }}
                    variant="link"
                    color="error"
                  >
                    <Typography variant="caption">{t("global.remove", "Remove")}</Typography>
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </ListItem>
        )
      })}
    </List>
  )
}

export default DepartmentsList
